"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAssistedAuthenticator = void 0;
const framework_1 = require("../../../framework");
const types_1 = require("../../../features/session/cc/types");
const timeOut_helper_1 = require("../../../features/timeOut/helpers/timeOut.helper");
const biometricValidation_1 = require("./biometricValidation");
class MbAssistedAuthenticator extends framework_1.BaseAuthenticator {
    constructor(session, xhr, modelbankUSDManager, urlConfig, getDeviceUUID, fetchIp) {
        super(session);
        this.username = '';
        this.interactionId = '';
        this.agentToken = '';
        this.documentType = 'user';
        /**
         * Know if user has trusted device
         * @param username string
         * @returns Promise<boolean>
         */
        this.userHasTrustedDevice = (username) => __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.xhr.POST(this.urlConfig.trustedDevice, {
                username,
                documentType: this.documentType,
            }, { headers: { accessToken: this.agentToken } });
            return !!resp.data;
        });
        /**
         * Initialize Assisted Login
         * @param username string
         * @param verifyOriginalActions AssistedLoginInitActionsType
         */
        this.init = (username, verifyOriginalActions) => __awaiter(this, void 0, void 0, function* () {
            this.username = username;
            const verifyActions = this.addLoginToActionSuccess(verifyOriginalActions);
            if (!this.biometricValidation) {
                this.biometricValidation = new biometricValidation_1.BiometricValidation({
                    verifyActions,
                    agentToken: this.agentToken,
                    interactionId: this.interactionId,
                    xhr: this.xhr,
                    urlConfig: this.urlConfig.biometricValidation,
                    getDeviceUUID: this.getDeviceUUID,
                    fetchIp: this.fetchIp,
                });
            }
            else {
                this.biometricValidation.updateVerifyActions(verifyActions);
            }
            yield this.biometricValidation.waitUserAuthorization(username);
        });
        /**
         * Check if the user has validated the challenge
         */
        this.manualVerify = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield ((_a = this.biometricValidation) === null || _a === void 0 ? void 0 : _a.manualVerify());
        });
        this.addLoginToActionSuccess = (verifyOriginalActions) => ({
            onSuccess: (verifyData) => __awaiter(this, void 0, void 0, function* () {
                yield this.login({
                    accessToken: verifyData.accessToken,
                    expiresIn: verifyData.expiresIn,
                    refreshToken: verifyData.refreshToken,
                    sessionExpiresAt: new Date(verifyData.sessionExpiresAt),
                    agentToken: this.agentToken,
                    username: this.username,
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(verifyData.expiresIn),
                    entrypoint: types_1.EntrypointType.AssistedLogin,
                });
                this.modelbankUSDManager
                    .getMethods()
                    .assistedAuthenticateSuccess(verifyData.accessToken, verifyData.refreshToken, verifyData.clientRole);
                verifyOriginalActions.onSuccess({ clientRole: verifyData.clientRole });
            }),
            onError: verifyOriginalActions.onError,
        });
        this.doLogin = (data) => __awaiter(this, void 0, void 0, function* () {
            if (!this.agentToken) {
                const { agentToken, interactionId, userName } = yield this.modelbankUSDManager.init();
                this.agentToken = agentToken;
                this.interactionId = interactionId;
                return {
                    agentToken,
                    interactionId,
                    username: userName,
                    accessToken: '',
                    refreshToken: '',
                    entrypoint: types_1.EntrypointType.AssistedLogin,
                };
            }
            return data;
        });
        this.doLogout = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const accessToken = (_a = this.getSession().getData()) === null || _a === void 0 ? void 0 : _a.accessToken;
            yield this.xhr.POST(this.urlConfig.logout, { accessToken });
        });
        this.xhr = xhr;
        this.modelbankUSDManager = modelbankUSDManager;
        this.urlConfig = urlConfig;
        this.getDeviceUUID = getDeviceUUID;
        this.fetchIp = fetchIp;
    }
}
exports.MbAssistedAuthenticator = MbAssistedAuthenticator;
//# sourceMappingURL=assisted.js.map